import React from "react";
import { Row, Col, Card, Statistic, Typography } from "antd";
import PropTypes from "prop-types";
import { formatDateOnly } from "Common/Components/FormatDateTime";
const { Text } = Typography;
export const TrainingLibrary = ({ courseLibraryStats, darkMode }) => {
  const styles = {
    card: {
      borderRadius: 8,
      marginBottom: 24,
      backgroundColor: darkMode ? "#1f1f1f" : "#fff",
      borderColor: darkMode ? "#303030" : "#f0f0f0",
    },
    cardTitle: {
      color: darkMode ? "rgba(255, 255, 255, 0.85)" : undefined,
    },
    textColor: {
      color: darkMode ? "rgba(255, 255, 255, 0.85)" : undefined,
    },
    secondaryTextColor: {
      color: darkMode ? "rgba(255, 255, 255, 0.45)" : "rgba(0, 0, 0, 0.45)",
    },
  };
  return (
    <Col xs={24} lg={8}>
      <Card title="Training Library" style={styles.card} styles={{ header: styles.cardTitle }}>
        <Row gutter={[16, 16]}>
          <Col xs={10}>
            <Statistic
              title={<Text style={styles.secondaryTextColor}>Business Groups</Text>}
              value={courseLibraryStats.fieldCount}
              valueStyle={styles.textColor}
            />
          </Col>
          <Col xs={8}>
            <Statistic
              title={<Text style={styles.secondaryTextColor}>Courses</Text>}
              value={courseLibraryStats.courseCount}
              valueStyle={styles.textColor}
            />
          </Col>
        </Row>
        <div style={{ marginTop: 16 }}>
          <Text strong style={{ ...styles.textColor, marginRight: 8 }}>
            Last Course Date:
          </Text>
          <Text style={styles.secondaryTextColor}>{`${formatDateOnly(
            courseLibraryStats.lastCourseDate
          )}`}</Text>
        </div>
        <div style={{ marginTop: 16 }}>
          <Text strong style={{ ...styles.textColor, marginRight: 8 }}>
            Recently Added:
          </Text>
          <Text style={styles.secondaryTextColor}>{courseLibraryStats.lastCourse}</Text>
        </div>
      </Card>
    </Col>
  );
};
TrainingLibrary.propTypes = {
  darkMode: PropTypes.bool.isRequired,
  courseLibraryStats: PropTypes.shape({
    fieldCount: PropTypes.number.isRequired,
    courseCount: PropTypes.number.isRequired,
    lastCourse: PropTypes.string.isRequired,
    lastCourseDate: PropTypes.string.isRequired,
  }).isRequired,
};
